// extracted by mini-css-extract-plugin
module.exports = {"NoCompanyPage":"NoCompanyPage_NoCompanyPage__1e2Vd","main":"NoCompanyPage_main__3MM9H"};